import type { ReactNode } from 'react';
import React from 'react';

import { inject, observer } from 'mobx-react';

import { bind } from 'bind-decorator';

import type { AuthStoreType } from 'bz-stores/lib/auth-store';

import type PermissionsStore from 'tm3-core/cache/stores/permissions-store';

import PermissionsContext from './context/permissions';

export interface IProps {
  authStore?: AuthStoreType;
  permissions?: PermissionsStore;
  children: ReactNode;
}

@inject('authStore', 'permissions')
@observer
class PermissionsProvider extends React.Component<IProps> {
  render() {
    return (
      <PermissionsContext.Provider value={this.canDoAction}>
        {this.props.children}
      </PermissionsContext.Provider>
    );
  }

  @bind
  canDoAction(rule: string, locationId?: number): boolean {
    const { authStore, permissions } = this.props;
    const { id: currentLocationId } = authStore!.user.location;

    return permissions!.canDoAction(rule, locationId || currentLocationId);
  }
}

export default PermissionsProvider;
